import { useContext } from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import SmartContextPage from '../../../library/Core/SmartContextPage';
import DomainExpertDirectoryService from './DomainExpertDirectoryService';
import DomainExpertSearchControl from './DomainExpertSearchControl';
import DomainExpertCardGridControl from './DomainExpertCardGridControl';
import DomainExpertSummaryCardControl from './DomainExpertSummaryCardControl';

const DomainExpertDirectory = () => {
    const { pageName } = useParams();
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();

    // The route loader already fetched everything (including a preloaded search) before
    // this component ever mounted, so the initial state is built synchronously here rather
    // than starting with isDataLoading: true and patching it in a moment later via effect —
    // that gap used to cause a second loader flash right after the route-transition loader.
    const { formConfig, data, internal } = useLoaderData() as State;
    const domain = globalState.domain;
    const searchFilterDomains = DomainExpertDirectoryService.getSearchFilterDomains(
        domain,
        (internal as any)?.searchFilterDomains
    );
    const filters = DomainExpertDirectoryService.getDefaultSearchCriteria();

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        data: { ...(data as any), searchDomain: searchFilterDomains, filters },
        formConfig,
        internal: { ...(internal as any), searchFilterDomains },
        domain,
        routeInfo: { pageName },
        flags: { isDataLoading: false, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { ROUTER_NAVIGATE: navigate },
    } as any);

    return (
        <SmartContextPage
            state={state}
            dispatch={dispatch}
            showDebug={false}>
            <>
                <DomainExpertSummaryCardControl />
                <DomainExpertSearchControl />
                <DomainExpertCardGridControl />
            </>
        </SmartContextPage>
    );
};

export default DomainExpertDirectory;
